import { useCallback, useEffect, useState } from "react";

import { getExamOptions, getTeacherEstablishments } from "../services/examsApi";

export default function useExamOptions() {
  const [options, setOptions] = useState(null);
  const [establishments, setEstablishments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [nextOptions, nextEstablishments] = await Promise.all([
        getExamOptions(),
        getTeacherEstablishments(),
      ]);
      setOptions(nextOptions || {});
      setEstablishments(nextEstablishments);
    } catch (requestError) {
      setOptions(null);
      setEstablishments([]);
      setError(requestError.response?.data?.detail || "Impossible de charger les options du générateur.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { options, establishments, loading, error, reload };
}
